import React from "react";
import { Link, withRouter } from "react-router-dom";
import { AppSettings } from "./../../config/app-settings.js";
import { menuMatchesLocation } from "./menuMatch.js";

function getPathname(props) {
  return props.location?.pathname ?? props.pathname ?? window.location.pathname ?? "/";
}

class SidebarNavList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: -1,
      clicked: -1,
    };
  }

  handleExpand = (e, i) => {
    e.preventDefault();
    this.setState({
      active: this.state.active === i ? -1 : i,
      clicked: 1,
    });
  };

  handleMenuItemClick = (e, toggleAppSidebarMobile) => {
    if (window.innerWidth <= 768 && !this.props.data.children) {
      setTimeout(() => {
        if (toggleAppSidebarMobile) {
          toggleAppSidebarMobile({
            preventDefault: () => {},
            stopPropagation: () => {},
            target: e.target,
          });
        }
      }, 150);
    }
  };

  handleExpandClick = (e, i, toggleAppSidebarMobile) => {
    if (typeof this.props.expand === "function") {
      this.props.expand(e);
    } else {
      this.handleExpand(e, i);
    }

    if (window.innerWidth <= 768 && this.props.data.path !== "#") {
      setTimeout(() => {
        if (toggleAppSidebarMobile) {
          toggleAppSidebarMobile({
            preventDefault: () => {},
            stopPropagation: () => {},
            target: e.target,
          });
        }
      }, 150);
    }
  };

  render() {
    const { data } = this.props;
    const pathname = getPathname(this.props);
    const routeMatch = menuMatchesLocation(pathname, data);

    const icon = data.icon && (
      <div className="menu-icon">
        <i className={data.icon}></i>
      </div>
    );
    const img = data.img && (
      <div className="menu-icon-img">
        <img src={data.img} alt="" />
      </div>
    );
    const caret = data.children && !data.badge && <div className="menu-caret"></div>;
    const label = data.label && <span className="menu-label ms-5px">{data.label}</span>;
    const badge = data.badge && <div className="menu-badge">{data.badge}</div>;
    const highlight = data.highlight && <i className="fa fa-paper-plane text-theme"></i>;
    const title = data.title && (
      <div className="menu-text">
        {data.title} {label} {highlight}
      </div>
    );

    return (
      <AppSettings.Consumer>
        {({
          handleAppSidebarOnMouseOver,
          handleAppSidebarOnMouseOut,
          appSidebarMinified,
          toggleAppSidebarMobile,
        }) => (
          <div
            className={
              "menu-item " +
              (routeMatch ? "active " : "") +
              (this.props.active ||
              (this.props.clicked === -1 && routeMatch) ||
              data.search
                ? "expand "
                : "closed ") +
              (data.children ? "has-sub " : "")
            }
          >
            {data.children ? (
              <Link
                to={data.path}
                className="menu-link"
                onMouseOver={(e) =>
                  handleAppSidebarOnMouseOver && handleAppSidebarOnMouseOver(e, data)
                }
                onMouseOut={(e) =>
                  handleAppSidebarOnMouseOut && handleAppSidebarOnMouseOut(e, data)
                }
                onClick={(e) => this.handleExpandClick(e, 0, toggleAppSidebarMobile)}
              >
                {img} {icon} {title}
                {caret} {badge}
              </Link>
            ) : (
              <Link
                to={data.path}
                className="menu-link"
                onClick={(e) => this.handleMenuItemClick(e, toggleAppSidebarMobile)}
              >
                {img} {icon} {badge} {title}
                {caret}
              </Link>
            )}
            {data.children && (
              <div
                className={
                  "menu-submenu " +
                  ((this.props.active ||
                    (this.props.clicked === -1 && routeMatch) ||
                    data.search) &&
                  !appSidebarMinified
                    ? "d-block "
                    : "d-none")
                }
              >
                {data.children.map((submenu, i) => (
                  <SidebarNavListWithRouter
                    data={submenu}
                    key={`${submenu.path}-${i}`}
                    pathname={pathname}
                    expand={(e) => this.handleExpand(e, i)}
                    active={i === this.state.active}
                    clicked={this.props.clicked}
                  />
                ))}
              </div>
            )}
          </div>
        )}
      </AppSettings.Consumer>
    );
  }
}

const SidebarNavListWithRouter = withRouter(SidebarNavList);

export default SidebarNavListWithRouter;
